<template>
  <v-card>
    <v-alert type="error" v-if="errorAllData">
      Data loading failed!
    </v-alert>

    <v-card-title>{{ country }}</v-card-title>

    <v-card-text class="mt-4" v-if="allData.length == 0 && !errorAllData">
      <v-row class="justify-center">
        <v-progress-circular
            class="mt-5 mb-5"
            :size="70"
            :width="7"
            color="#00aeef"
            indeterminate
        ></v-progress-circular>
      </v-row>
    </v-card-text>

    <v-card-text class="mt-4" v-if="allData.length > 0 && !errorAllData">
      <v-row class="mx-0"></v-row>
      <div ref="spacer_orphanhood" class="spacer"></div>
      <img :src="orphanhoodImg" align="right" class="card-icon">
      <v-row class="mx-0 subtitle">Orphanhood estimates:</v-row>
      <v-row class="mx-0 estimate">
        {{ details["orphanhood"] | formatNumber }}
      </v-row>
      <v-row class="mx-0 subtitle-description mt-4">
        (death of one or both parents)
      </v-row>
    </v-card-text>
    <v-card-text v-show="isLinePlotShown">
      <v-alert type="error" v-if="errorCountryData">
        Failed to load plot!
      </v-alert>
      <v-row class="mx-0" ref="plotRow" v-else>
        <div ref="plot" id="plot"></div>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text v-if="allData.length > 0 && !errorAllData">
      <div ref="spacer_primary" class="spacer"></div>
      <img :src="primaryImg" align="right" class="card-icon">
      <v-row class="mx-0 subtitle">
        Estimates of loss of primary caregiver:
      </v-row>
      <v-row class="mx-0 estimate">
        {{ details["primary"] | formatNumber }}
      </v-row>
      <v-row class="mx-0 subtitle-description mt-4">
        (death of one or both parents or death of custodial grandparents)
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text v-if="allData.length > 0 && !errorAllData">
      <div ref="spacer_primary_or_secondary" class="spacer"></div>
      <img :src="primaryOrSecondaryImg" align="right" class="card-icon">
      <v-row class="mx-0 subtitle">Estimates of children losing primary or secondary caregivers:
      </v-row>
      <v-row class="mx-0 estimate">
        {{ details["primary_secondary"] | formatNumber }}
      </v-row>
      <v-row class="mx-0 subtitle-description mt-4 mb-1">
        (death of one or both parents, death of custodial grandparents, and/or death of other co-residing grandparents)
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import  Plotly  from 'plotly.js-dist/plotly';

export default {
  name: "CountryCard",
  props: ['selectedCountry', 'selectedDate'],
  data() {
    return {
      plotData:[{ x: [1,2,3,4], y: [10,15,13,17], type:"scatter" }],
      countryData: null,
      allData: [],
      showInitial: true,
      orphanhoodImg: 'images/orphanhood.svg?r=' + Math.random(),
      primaryImg: 'images/primary.svg?r=' + Math.random(),
      primaryOrSecondaryImg: 'images/primary_or_secondary.svg?r=' + Math.random(),
      errorCountryData: false,
      errorAllData: false,
      config: null
    }
  },
  created() {
    this.loadData();
    this.loadPlotData();
    this.loadConfig();
  },
  watch: {
    selectedDate: function () {
      this.loadData();
    },
    selectedCountry: function() {
      this.loadPlotData();
      this.restartAnimations();
    },
    countryData: function () {
      const x = this.countryData.map(data => data.date);
      const y = this.countryData.map(data => data.orphanhood);

      var plotHeight = 175;

      if(this.$refs.plotRow.clientWidth < 500) {
        plotHeight = 120;
      }

      Plotly.newPlot(this.$refs.plot, /* JSON object */ {
        "data": [{
          type: "scatter",
          "x": x,
          "y": y,
          mode: 'lines',
          line: {
            color: 'rgb(0, 174, 239)',
            width: 4
          }
        }],
        "layout": {
          "autosize": true,
          "height": plotHeight,
          width: this.$refs.plotRow.clientWidth,
          //"width": "100%"
          margin: {
            l: 55,
            r: 0,
            b: 20,
            t: 0,
            pad: 0
          },
          xaxis: {
            showgrid: false
          },
          yaxis: {
            showgrid: true,
            gridcolor: '#eeeeee',
            hoverformat: ',',
            title: {
              text: 'Children',
              font: {
                family: 'Roboto, sans-serif',
                size: 15,
                color: '#7f7f7f'
              }
            }
          }
        },
        "config": {
          displayModeBar: false
        }
      });

      this.checkSpacer();
    }
  },
  computed: {
    country: function () {
      return this.selectedCountry;
    },
    details: function () {
      return this.allData.filter(entry => entry.country == this.selectedCountry)[0];
    },
    isLinePlotShown: function() {
      if(this.config === null) {
        //(async () => await this.loadConfig())();
        console.info("Config not loaded yet");
        return false;
      }

      if(!('show_line_plot' in this.config)) {
        console.error("Configuration key show_line_plot missing!")
        return false;
      }

      console.debug("Config loaded: " + this.config.show_line_plot.indexOf(this.selectedCountry))
      return this.config.show_line_plot.indexOf(this.selectedCountry) >= 0;
    }
  },
  filters: {
    formatNumber: function (num) {
      let result = num;

      if(num >= 1000) {
        result = Math.round(num/100) * 100;
      } else if(num >= 100) {
        result = Math.round(num/10) * 10;
      } else {
        result = num;
      }

      return result.toLocaleString('en-US');
    }
  },
  methods: {
    async loadData() {
      this.allData = await fetch('data/details/' + this.selectedDate + '.json')
          .then((response) => {
            if(response.ok) {
              this.errorAllData = false;
            } else {
              this.errorAllData = true;
              return [];
            }

            return response.json()
          }).catch((error) => {
            console.error(error);

            this.errorAllData = true;
          });
    },
    async loadPlotData() {
      this.countryData = await fetch('data/timeseries/' + this.selectedCountry + '.json')
          .then((response) => {
            this.errorCountryData = !response.ok;

            return response.json()
          })
          .catch((error) => {
            console.error(error);
            this.errorCountryData = true;
          });
    },
    async loadConfig() {
      this.config = await fetch('config/country_card.json')
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error(error);
          this.errorCountryData = true;
        });
    },
    onResize() {
      Plotly.update(this.$refs.plot, {}, { width: this.$refs.plotRow.clientWidth });
      this.checkSpacer();
    }, 
    sizeSpacer(spacer) {
      spacer.style.height = 0;
      var container = spacer.parentNode;
      var img = spacer.nextElementSibling || spacer.nextSibling;
      var lastContentNode = container.children[container.children.length - 1];
      var h = Math.max(0, container.clientHeight - img.clientHeight);
      spacer.style.height = h + "px";
      while (h > 0 && img.getBoundingClientRect().bottom > lastContentNode.getBoundingClientRect().bottom) {
        spacer.style.height = --h + "px";
      }
      if (lastContentNode.getBoundingClientRect().bottom > img.getBoundingClientRect().bottom) {
        spacer.style.height = ++h + "px";
      }
    },
    checkSpacer() {
      if (this.allData.length > 0) {
        Plotly.update(this.$refs.plot, {}, { width: this.$refs.plotRow.clientWidth });

        this.sizeSpacer(this.$refs.spacer_orphanhood);
        this.sizeSpacer(this.$refs.spacer_primary);
        this.sizeSpacer(this.$refs.spacer_primary_or_secondary);
      } else {
        setTimeout(() => this.checkSpacer(), 200);
      }
    },
    restartAnimations() {
      this.orphanhoodImg = 'images/orphanhood.svg?r=' + Math.random();
      this.primaryImg = 'images/primary.svg?r=' + Math.random();
      this.primaryOrSecondaryImg = 'images/primary_or_secondary.svg?r=' + Math.random();
    }
  },
  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize);

    this.checkSpacer();

    this.showInitial = false;
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>

.estimate {
  color: #00aeef;
  font-weight: 700;
  font-size: 2.1em;
  padding-top: 0.4em;
  padding-bottom: 0.1em;
}

.spacer {
  height: 6em;
  width: 0px;
  float: right;
}

.card-icon {
  height: 6.5em;
  margin-left: 1em;
  float: right;
  clear: right;
}

@media (min-width: 576px) {
  .card-icon {
    margin-top: -1.5em;
  }
}

.subtitle {
  font-weight: 600;
  color: #444;
}

.subtitle-description {
  color: #999;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity 2s ease;
}
.component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
